import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { ConstructPatch } from '../../types/ConstructPatch';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const updateEnvelope = (
  constructPatch: ConstructPatch,
  envelopeId: string,
  data: Record<string, any>,
): Promise<unknown> =>
  constructPatch(
    `${SIGNATURE_BASE_PATH}/envelope/${envelopeId}`,
    { data },
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
